module.exports = __WEBPACK_EXTERNAL_MODULE_4__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ol","amd":"openlayers","commonjs":"openlayers","commonjs2":"openlayers"}
// module id = 4
// module chunks = 0